class Header {
    selectorHeader: Element | null

    constructor(headerClass: string = 'site-header') {
        this.selectorHeader = document.querySelector(`.${headerClass}`)
    }

    toggleHeader(enableLongHeader: boolean = false, controlSearch: boolean = false) {
        if (this.selectorHeader) {
            this.selectorHeader.classList.toggle('active')

            if (enableLongHeader) {
                this.selectorHeader.classList.toggle('activeSubmenu')
            }

            this.selectorHeader.classList[controlSearch ? 'add' : 'remove']('activeSearch')

        }
    }
}

export default Header